import { Component, AfterViewInit } from '@angular/core';
import { RightHistoryComponent } from '../../history/right-history/right-history.component'

@Component({
    selector: '[app-drivers-analitics]',
    templateUrl: './drivers-analitics.component.html',
    styleUrls: ['./drivers-analitics.component.css'],
    standalone: false
})
export class DriverAnaliticsComponent extends RightHistoryComponent implements AfterViewInit
{
  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "DriversAnalitics" }));
    this.openTabTrackingRight('table_info', 2);
  }
}
